/// <reference path="../../../../node_modules/@types/adal/index.d.ts" />
import { Headers } from '@angular/http';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { ConfigService } from './config.service';
import 'expose-loader?AuthenticationContext!../../../../node_modules/adal-angular/lib/adal.js';
let createAuthContextFn: adal.AuthenticationContextStatic = AuthenticationContext;

@Injectable()
export class AdalService {
    private context: adal.AuthenticationContext;

    constructor(private configService: ConfigService) {
        this.context = new createAuthContextFn(configService.getAdalConfig);
    }

    login() {
        this.context.login();
    }

    logout() {
        this.context.logOut();
    }

    handleCallback() {
        this.context.handleWindowCallback();
    }

    public get userInfo() {
        return this.context.getCachedUser();
    }

    public get accessToken() {
        var token = this.context.getCachedToken(this.configService.getAdalConfig.clientId);
        if (!token) {
            if (confirm("You must log back in, please press OK to continue.")) this.login();
        }
        return token;
    }

    public get isAuthenticated() {
        return this.userInfo && this.accessToken;
    }

    public createServiceHeader(): Headers {
        var headers: Headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', 'Bearer ' + this.accessToken);
        return headers;
    }
} 



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/azure-authentication/adal.service.ts